import { createContext, useContext } from "react";
import type IResponsiveAuth from "../responsive-auth.interface";

export const ResponsiveAuthContext = createContext<IResponsiveAuth | null>(
    null,
);

export function useResponsiveAuth(): IResponsiveAuth {
    const context = useContext(ResponsiveAuthContext);
    if (!context) {
        throw new Error(
            "useResponsiveAuth must be used within ResponsiveAuthProvider",
        );
    }
    return context;
}
